export enum NetworkStatus {
    CONNECTED,
    DISCONNECTED,
    RECONNECTING
}
